module.exports = __webpack_public_path__ + "img/36.e527fe1f.jpg";